/**
 * Predictive search: debounced fetch of the "predictive-search" section via
 * the Section Rendering API, with a citrus skeleton while loading. Without
 * JS the form submits to the regular search page.
 * ponytail: plain link-list a11y; upgrade to combobox/listbox ARIA if audits demand.
 */
if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-search-results]');
      this.skeleton = this.querySelector('[data-search-skeleton]');
      this.status = this.querySelector('[data-search-status]');
      this.details = this.closest('details');
      this.abortController = null;
      this.debounceTimer = null;

      this.input.addEventListener('input', () => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.search(this.input.value.trim()), 300);
      });

      this.details?.addEventListener('toggle', () => {
        if (this.details.open) this.input.focus();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details?.open) this.details.open = false;
      });

      document.addEventListener('click', (event) => {
        if (this.details?.open && !this.details.contains(event.target)) this.details.open = false;
      });
    }

    async search(query) {
      this.abortController?.abort();
      if (!query) {
        this.results.innerHTML = '';
        this.skeleton.hidden = true;
        return;
      }
      this.abortController = new AbortController();
      this.skeleton.hidden = false;

      try {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product',
          'resources[limit]': '6',
          section_id: 'predictive-search',
        });
        const response = await fetch(`${this.dataset.url}?${params}`, {
          signal: this.abortController.signal,
        });
        if (!response.ok) throw new Error(String(response.status));
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        this.results.innerHTML = '';
        // bring both the results and their inline <style> along
        parsed.querySelectorAll('.predictive-search, style').forEach((node) => {
          this.results.appendChild(node);
        });
        this.skeleton.hidden = true;
        const count = Number(this.results.querySelector('.predictive-search')?.dataset.count || 0);
        this.status.textContent = (this.dataset.statusTemplate || '').replace('[count]', String(count));
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.skeleton.hidden = true;
      }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
}
